<template>
  <vx-card>
    <validation-observer ref="validator" #default="{valid}">
      <b-form
        :class="[inline ? 'gap-2 items-center' : '']"
        :inline="inline"
        @submit.prevent="onSubmit"
        @reset.prevent="clear"
        @reset="onReset"
        v-if="show"
      >
        <b-row class="v-row">
          <b-col class="v-col-sm-12 v-col-md-12 v-col-lg-8">
            <validation-provider
              #default="validationContext"
              :name="$t('document_title')"
              rules="required"
              class="flex-grow"
              slim
            >
              <b-form-group
                id="input-group-1"
                :label="$t('document_title')"
                label-for="document_title"
              >
                <b-form-input
                  id="document_title"
                  v-model="item.title"
                  class="required"
                >
                </b-form-input>
                <b-form-invalid-feedback :class="[{ absolute: inline }]">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider
              #default="validationContext"
              :name="$t('document_category')"
              rules="required"
              class="flex-grow"
              slim
            >
              <b-form-group
                id="input-group-2"
                :label="$t('document_category')"
                label-for="document_category"
              >
                <b-form-select
                  id="document-category"
                  class="required-select"
                  :options="documentCategories"
                  text-field="name"
                  value-field="id"
                  v-model="item.document_category_id"
                />
                <b-form-invalid-feedback :class="[{ absolute: inline }]">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <b-form-group
              id="input-group-3"
              :label="$t('document_description')"
              label-for="document_description"
            >
              <simple-editor
                v-model="item.description"
                class="mb-2"
              ></simple-editor>
            </b-form-group>
          </b-col>
          <b-col
            class="v-col-sm-12 v-col-md-12 v-col-lg-4 border-4 border-red-200 border-x-red-500 mx-auto max-w-md"
          >
            <h5 class="mr-1">{{ $t('document_security') }}</h5>
            <vs-divider color="warning" />

            <b-form-group
              :label="$t('document_access')"
              v-slot="{ ariaDescribedby }"
            >
              <b-form-radio-group
                id="btn-radios-2"
                @click.native="handlingRadioAccess"
                v-model="item.media_access"
                :options="mediaAccessList"
                :aria-describedby="ariaDescribedby"
                button-variant="outline-primary"
                name="radio-btn-outline"
                size="sm"
                buttons
              ></b-form-radio-group>
            </b-form-group>

            <b-form-group
              :label="$t('document_access_by_code')"
              label-for="accessByCode"
            >
              <b-form-radio-group
                id="accessByCode"
                name="accessByCode"
                v-model="item.access_by_code"
              >
                <b-form-radio :value="true">{{ $t('yes') }}</b-form-radio>
                <b-form-radio :value="false">{{ $t('no') }}</b-form-radio>
              </b-form-radio-group>
            </b-form-group>

            <b-form-group
              id="input-group-6"
              :label="$t('document_password')"
              label-for="document_password"
            >
              <b-form-input id="document_password" v-model="item.password">
              </b-form-input>
            </b-form-group>
            <vs-divider color="warning" />
          </b-col>
        </b-row>

        <!-- -->
        <div class="flex flex-row justify-end gap-4 mt-2">
          <b-button type="submit" variant="primary" :disabled="!valid"
            >Salvar</b-button
          >
          <b-button
            v-if="isEdit()"
            type="button"
            class="btn waves-effect outline-primary"
            variant="outline-secondary"
            v-permission="'documents.data_access'"
            @click="showDataAccess = true"
          >
            {{ $t('action.colaboration') }}
          </b-button>

          <b-button @click="goBack" variant="outline-secondary"
            >Voltar</b-button
          >
        </div>

        <b-row class="m-0" v-if="isEdit() && !item.access_by_code">
          <b-col lg="12">
            <vs-divider></vs-divider>
            <b-card-code
              :key="id"
              title="URL pública (Somente quando o acesso não for pelo token)"
              codeVisible="true"
              showCopy="true"
            >
              <template #code>
                {{ item.public_url }}
              </template>
            </b-card-code>
          </b-col>
        </b-row>

        <b-row class="m-0" v-if="isEdit()">
          <b-col lg="12">
            <h5 class="mt-2 mb-0">{{ $t('document_subtitle_document') }}</h5>
            <vs-divider></vs-divider>
          </b-col>
        </b-row>

        <b-row class="pt-2 pb-2" v-if="isEdit()">
          <b-col lg="12" md="12">
            <vue-dropzone
              id="upload"
              ref="fileUploadZone"
              @vdropzone-processing="dropzoneChangeUrl"
              v-on:vdropzone-success="successSendFile"
              v-on:vdropzone-error="error"
              v-on:vdropzone-file-added="added"
              v-on:vdropzone-queue-complete="complete"
              :use-font-awesome="true"
              :options="dropzoneOptions"
              :use-custom-dropzone-options="true"
              :useCustomSlot="true"
              @vdropzone-file-added="fileAdded"
            >
              <div class="dropzone-custom-content">
                Arraste e solte para enviar um arquivo
                <p class="separator">
                  <span class="separator-span"> ou </span>
                </p>
                <b-button
                  type="button"
                  class="btn waves-effect outline-primary"
                  variant="outline-secondary"
                  >Selecionar</b-button
                >
              </div>
            </vue-dropzone>
          </b-col>
        </b-row>

        <b-row class="pt-2" v-if="isEdit()">
          <b-col md="12">
            <media-list
              :medias="files"
              :show-delete="true"
              :action-on-click="false"
              @deleteMedia="deleteMedia"
            />
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    <role-popup
      :visible="showPopupRole"
      @selected="addRolesList"
      :idsSelected="idsRolesSelected"
      @close="showPopupRole = false"
      v-if="item.media_access === 'GROUP'"
    />

    <vs-popup
      :title="$t('document_colaboration')"
      :active.sync="showDataAccess"
    >
      <data-access-form
        v-if="$acl.hasPermission('documents.data_access')"
        modelType="documents"
        :modelId="id"
      />
    </vs-popup>
  </vx-card>
</template>

<script>
import SelectSuggestion from '@/components/SelectSuggestion.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, min, email } from '@validations'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import standard from '@/services/standard'

import RolePopup from './../roles/RolePopup.vue'

import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormRadioGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BFormCheckbox,
  BFormRadio,
  BButton,
  BFormInvalidFeedback,
  VBTooltip
} from 'bootstrap-vue'

import DocumentService from '@/services/api/DocumentService'
import MediaList from '@/components/media/MediaList.vue'
import BCardCode from '@core/components/b-card-code'
import SimpleEditor from '@/components/SimpleEditor.vue'

import DataAccessForm from '@/components/DataAccessForm'

export default {
  directives: {
    'b-tooltip': VBTooltip
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormRadioGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BFormCheckbox,
    BFormRadio,
    BButton,
    ValidationObserver,
    ValidationProvider,
    BFormInvalidFeedback,
    vueDropzone: vue2Dropzone,
    MediaList,
    BCardCode,
    SimpleEditor,
    SelectSuggestion,
    RolePopup,
    DataAccessForm
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    showDataAccess: false,
    service: null,
    item: {
      title: '',
      description: '',
      password: '',
      media_access: 'PUBLIC', //default
      access_by_code: true, //default
      group_list: [],
      document_category_id: ''
    },
    isPublic: true,
    mediaAccessList: [
      { text: 'Público', value: 'PUBLIC' },
      { text: 'Logado', value: 'LOGGED' },
      { text: 'Proprietário', value: 'OWNER' },
      { text: 'Grupo', value: 'GROUP' }
    ],
    dropzoneOptions: {
      headers: { Authorization: `Bearer ${standard.token()}` },
      url: 'url', //set in dropzoneChangeUrl
      addRemoveLinks: true,
      autoProcessQueue: true,
      timeout: 180000,
      thumbnailWidth: 200,
      parallelUploads: 20,
      maxFiles: 20,
      createImageThumbnails: true,
      dictInvalidFileType: 'Arquivos somente no formato PDF',
      dictRemoveFile: 'Remover arquivo'
    },
    documentCategory: {},
    documentCategories: [],
    files: [],
    show: true,
    required,
    email,
    min,
    showPopupRole: false
  }),
  methods: {
    loadDocumentCategories() {
      return this.service.getCategories().then(
        response => {
          this.documentCategories = [...response]
        },
        error => {
          console.error('whoops')
        }
      )
    },
    onReset() {
      console.log('reset form')
    },
    onSubmit() {
      const item = this.handlingModelData()
      if (this.id) {
        item.id = this.id
      }
      this.$vs.loading()
      return this.service
        .createOrUpdate(item)
        .then(
          response => {
            this.notifySuccess(this.$vs, 'Operação realizada com sucesso!')
            this.item.title = response.title
            this.item.description = response.description
            this.item.password = response.password
            ;(this.item.media_access = response.media_access),
              (this.item.custom_properties = response.custom_properties),
              (this.item.group_list = this._.get(
                response,
                'custom_properties.group_list',
                []
              )),
              (this.item.document_category_id = response.document_category_id)
            if (!this.isEdit()) {
              this.$router.replace({
                name: 'document-edit',
                params: {
                  id: response.id
                }
              })
            }
          },
          error => {
            this.notifyError(
              this.$vs,
              'Erro! não foi possível concluir esta operação'
            )
            console.error(error)
          }
        )
        .finally(() => this.$vs.loading.close())
    },
    handlingModelData() {
      if (this.isEdit()) {
        let accessControl = this.item.custom_properties
        if (accessControl) {
          let obj =
            typeof accessControl === 'object'
              ? accessControl
              : JSON.parse(accessControl)
          obj.access_control = [this.item.media_access]
          obj.access_by_code = this.item.access_by_code
          obj.group_list = this.item.group_list
          this.item.custom_properties = obj
        } else {
          this.item.custom_properties = {
            access_control: [this.item.media_access],
            access_by_code: this.item.access_by_code,
            group_list: this.item.group_list
          }
        }
      } else {
        this.item.custom_properties = {
          access_control: [this.item.media_access],
          access_by_code: this.item.access_by_code,
          group_list: this.item.group_list
        }
      }

      if (this.item.custom_properties.access_control[0] !== 'GROUP') {
        this.item.custom_properties.group_list = []
      }

      return this.item
    },
    getData() {
      return this.service.read(this.id).then(
        response => {
          this.item.title = response.title
          this.item.description = response.description
          this.item.password = response.password
          ;(this.item.media_access = response.media_access),
            (this.item.custom_properties = response.custom_properties),
            (this.item.group_list = this._.get(
              response,
              'custom_properties.group_list',
              []
            )),
            (this.item.document_category_id = response.document_category_id)
          this.item.public_url = response.public_url
          this.files = response.files
        },
        error => {
          console.error('oh no!')
        }
      )
    },
    goBack() {
      this.$router.push({
        name: 'document-index'
      })
    },
    isEdit() {
      return this.id != null || this.id != undefined
    },
    dropzoneChangeUrl() {
      this.$refs.fileUploadZone.setOption('url', this.getFileUploadUrl)
    },
    successSendFile(data) {
      this.getData() //reload with files upload
      this.$vs.loading.close()
      this.notifySuccess(this.$vs, 'Documento anexado com sucesso!')
      this.$refs.fileUploadZone.removeAllFiles()
    },
    deleteMedia(media) {
      this.$vs.loading()
      const handlingId = _.get(this.item, 'id')

      this.service
        .deleteAttachment(this.id, media.id)
        .then(
          data => {
            this.notifySuccess(this.$vs, 'Anexo removido!')
            //Update list files
            let newListfiles = _.remove(this.files, function(element) {
              return element.id !== media.id
            })
            this.files = newListfiles
          },
          error => {
            this.notifyError(this.$vs, 'Não foi possível remover o anexo.')
          }
        )
        .finally(() => {
          this.$vs.loading.close()
        })
    },
    handlingRadioAccess(e) {
      this.showPopupRole = e.target.value === 'GROUP'
    },
    addRolesList(roleList) {
      this.item.group_list = [] //zero, to new
      roleList.forEach(element => {
        this.item.group_list.push(element.id)
      })
    }
  },
  computed: {
    getFileUploadUrl() {
      const base = `${process.env.VUE_APP_API_BASE_URL}/api/v1`
      return `${base}/documents/${this.id}/files`
    },
    idsRolesSelected() {
      return this._.get(this.item, 'group_list', [])
    }
  },
  beforeMount() {
    this.service = DocumentService.build(this.$vs)

    this.show = false
    const bootstrapRequests = []

    this.$vs.loading()

    bootstrapRequests.push(this.loadDocumentCategories())

    if (this.id) {
      bootstrapRequests.push(this.getData(this.id))
    }

    Promise.all(bootstrapRequests)
      .then(() => (this.show = true))
      .finally(() => this.$vs.loading.close())
  }
}
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/simple-content.scss';
::v-deep .vs-popup {
  width: 800px !important;
}
</style>
